import tw, { styled } from 'twin.macro';

export const EmployerPageContentWrapper = styled.div`
  ${tw`pb-20 px-4 lg:px-10 xl:px-20 max-w-screen-xl mx-auto`}
`;
